import { lazy } from "react";
// Assignment (legacy) — pantalla previa al módulo `assignments`. Sigue ruteada
// en /Assignment aunque no está expuesta en el sidebar.
const Assignment = lazy(() => import("./Assignment"));
// `assignmentLegacyRoutes` y no `assignmentRoutes`: ese nombre ya lo usa el
// módulo `assignments` (el vigente).
export const assignmentLegacyRoutes = [
  { path: "/Assignment", element: <Assignment /> },
];

export { Assignment };
